import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Reverse words in a string",
  url: "reverse-words-string",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {string} str
* @return {string}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function reverse(str) {
  // your code goes here        
};
`,
};

export default info;
